import React, { useEffect, useState } from 'react';
import { Button, Switch, withStyles, TextField} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import PapperBlock from '../../../components/PapperBlock';
import { SettingIcon } from '../../../constants/icons';
import InputField from '../../../components/InputField';
import ImageDropzone from '../../../components/Dropzone/ImageDropzone';
import { getLeftBannerData, updateLeftBanner } from '../requests';
import { ADMIN_SETTING_ROUTE } from '../../../constants/routes';
import { DATE_FORMAT, DATE_FORMAT_TO_DB, DATE_TIME_FORMAT } from '../../../constants/dateTimeFormat';
import classNames from 'classnames';
import styles from '../../../styles';
import { format } from 'date-fns';
import {maxImageFileSize} from "../../../constants/additional";

const LeftBanner = ({ classes }) => {
  const [bannerData, setBannerData] = useState({});
  const [title, setTitle] = useState('');
  const [link, setLink] = useState('');
  const [pictureFile, setPictureFile] = useState([]);
  const [pictureUrl, setPictureUrl] = useState([]);
  const [pictureToDelete, setPictureToDelete] = useState([]);
  const [active, setActive] = useState(0);
  const [publishDate, setPublishDate] = useState(null);
  const [unpublishDate, setUnpublishDate] = useState(null);

  const history = useHistory();

  async function processingRequest() {
    setBannerData((await getLeftBannerData()).data);
  }

  useEffect(() => {
    processingRequest();
  }, []);

  useEffect(() => {
    setTitle(bannerData.title);
    setPictureUrl(bannerData.picture);
    setLink(bannerData.link);
    setActive(bannerData.active);
    setPublishDate(bannerData.publish_date ? new Date(bannerData.publish_date) : bannerData.publish_date);
    setUnpublishDate(bannerData.unpublish_date ? new Date(bannerData.unpublish_date) : bannerData.unpublish_date);
  }, [bannerData]);

  const submitHandler = async (event) => {
    event.preventDefault();
    const response = await updateLeftBanner({
      title,
      link,
      pictureUrl,
      pictureToDelete,
      active,
      publishDate: publishDate ? format(publishDate, DATE_FORMAT_TO_DB) : null,
      unpublishDate: unpublishDate ? format(unpublishDate, DATE_FORMAT_TO_DB) : null,
    },
    pictureFile[0]);
    // await createPoll();
    if (response.ok) {
      history.push(ADMIN_SETTING_ROUTE);
    }
  };

  console.log(bannerData);

  return (
    <PapperBlock title="Обновить левый банер" icon={<SettingIcon />}>
      <form onSubmit={submitHandler}>
        <InputField title="Название:" value={title} setValue={setTitle} />

        <InputField title="Ссылка:" value={link} setValue={setLink} />

        <ImageDropzone
          files={pictureFile}
          setFiles={setPictureFile}
          urls={pictureUrl}
          setUrls={setPictureUrl}
          toDelete={pictureToDelete}
          setToDelete={setPictureToDelete}
          text="Загрузить картинку"
          filesLimit={1}
          acceptedFiles={['image/*']}
          maxSize={maxImageFileSize}
        />
        Активность баннера
        <Switch
          color="primary"
          checked={active}
          onChange={(e) => {
            setActive(e.target.checked);
          }}
        />
        <div className={classNames(classes.field, classes.dateRow)}>
          <div className={classes.dateColumn}>
            <div className={classes.dateRow}>Дата публикации:</div>
            <TextField
              className={classes.dateRow}
              type="datetime-local"
              value={
                publishDate ? format(publishDate, DATE_TIME_FORMAT) : undefined
              }
              onChange={(e) => {
                setPublishDate(Date.parse(e.target.value));
              }}
            />
          </div>
          <div className={classes.dateColumn}>
            <div className={classes.dateRow}>Дата снятия с публикации:</div>
            <TextField
              className={classes.dateRow}
              type="datetime-local"
              value={
                unpublishDate
                ? format(unpublishDate, DATE_TIME_FORMAT)
                : undefined
              }
              onChange={(e) => {
                setUnpublishDate(Date.parse(e.target.value));
              }}
            />
          </div>
        </div>

        <Button variant="contained" color="primary" type="submit" fullWidth>
          Сохранить изменения
        </Button>
      </form>
    </PapperBlock>
  );
};
export default withStyles(styles)(LeftBanner);

LeftBanner.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
};

LeftBanner.defaultProps = {
  classes: {},
};
